import CallRecordingApiSetupForm from "../components/sidekick/CallRecordingApiSetupForm";
import { Card, Page, PageHeader, ui } from "../components/ui";

// Optional for admins: Sidekick works for meetings without call recording
function ConfigureSidekick() {
  return (
    <Page maxWidth={640}>
      <PageHeader
        eyebrow="Admin"
        title="Set up iPECS call recording"
        subtitle="Optional. Meetings work without it."
      />
      <Card style={{ padding: "24px 28px" }}>
        <p style={ui.muted}>
          Enter your call recording API details to allow Sidekick to transcribe
          and summarise your calls.
        </p>
        <p style={ui.muted}>
          If you're unsure of your call recording API details, please speak to
          your phone system administrator.
        </p>
        <CallRecordingApiSetupForm />
      </Card>
    </Page>
  );
}

export default ConfigureSidekick;
